import React, { useRef, useState } from 'react'
import { GallerySliderProps } from './GallerySlider.types'
import styles from './GallerySlider.module.scss'
import cl from 'classnames'
import { useMaxWidth } from './GallerySlider.utils'
import { IconArrowLeft, IconArrowRight } from 'assets'
import { Button } from '../Button'

const GallerySliderComponent = (props: GallerySliderProps) => {
  const {
    children,
    maxWidthCorrection,
    className,
    style = {}
  } = props

  const containerRef = useRef<HTMLDivElement>(null)
  const maxWidth = useMaxWidth(containerRef, maxWidthCorrection, children)

  const sliderRef = useRef<HTMLDivElement>(null)

  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  const onScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const { scrollLeft, offsetWidth, scrollWidth } = event.currentTarget

    const isScrollOnLeft = scrollLeft === 0
    const isScrollOnRight = offsetWidth + scrollLeft >= scrollWidth

    if (isScrollOnLeft === canScrollLeft) setCanScrollLeft(!isScrollOnLeft)
    if (isScrollOnRight === canScrollRight) setCanScrollRight(!isScrollOnRight)
  }

  const onLoad = (event: React.SyntheticEvent<HTMLDivElement, Event>) => {
    const { scrollWidth, clientWidth } = event.currentTarget
    const isScrollable = scrollWidth > clientWidth
    isScrollable && setCanScrollRight(true)
  }

  if (!children || (Array.isArray(children) && !children.length)) return null

  return (
    <div
      ref={containerRef}
      className={cl(styles.container, className)}
      style={{ maxWidth, ...style }}
    >

      <div
        ref={sliderRef}
        className={styles.gallerySlider}
        onScroll={onScroll}
        onLoad={onLoad}
      >
        {maxWidth && children}
      </div>

      <div className={cl(styles.leftButtonContainer, {
        [styles.displayNone]: !canScrollLeft
      })}
      >
        <Button
          preset='icon'
          className={styles.arrowButton}
          onClick={() => {
            sliderRef.current.scrollBy({
              behavior: 'smooth',
              left: -161
            })
          }}
        >
          <IconArrowLeft />
        </Button>
      </div>

      <div className={cl(styles.rightButtonContainer, {
        [styles.displayNone]: !canScrollRight
      })}
      >
        <Button
          preset='icon'
          className={styles.arrowButton}
          onClick={() => {
            sliderRef.current.scrollBy({
              behavior: 'smooth',
              left: 161
            })
          }}
        >
          <IconArrowRight />
        </Button>
      </div>

    </div>
  )
}

const GallerySlider = GallerySliderComponent
export { GallerySlider }
